/**
 * Returns route without step path
 * @param  {string} url - full url path
 * @returns string - base url
 */
export const getOrderBuilderBasePath = (url: string): string => {
  const urlArray = url.split('/');
  urlArray.pop();
  return urlArray.join('/');
};

/**
 * Gets the last part of a URL, surprisingly enough.
 * @param {string} url
 * @returns {string}
 */
export const getLastSegmentOfUrl = (url: string): string => {
  /* remove optional end '/' */
  const processed_url = url.replace(/\/$/, '');
  return processed_url.substr(url.lastIndexOf('/') + 1);
};

export enum ORDER_BUILDER_ROUTES {
  BusinessLine = 'business-line',
  Location = 'location',
  Specification = 'specification',
  RetailSpecification = 'retail-specification',
  Schedule = 'schedule',
  RetailReview = 'retail-review',
  Review = 'review',
  Summary = 'summary',
  RmsSpecification = 'rms-specification',
  RmsSummary = 'rms-summary',
  LocationAndSpecification = 'location-specification',
  BlkSummary = 'blk-summary',
  MultipleOrderConfirm = 'multiple-order-confirmation',
  AdtSpecification = 'adt-specification',
  AdtSummary = 'adt-summary',
}

export enum MODIFY_AND_REPEAT_BUILDER_ROUTES {
  LocationAndSpecification = 'location-specification',
  Review = 'review',
  BulkAdmixture = 'bulk-admixture',
  BulkAdmixtureReview = 'bulk-admixture-review',
  BulkAdmixtureSummary = 'bulk-admixture-summary',
}

export enum CEMENT_MODIFY_AND_REPEAT_BUILDER_ROUTES {
  LocationAndSpecification = 'location-specification',
  Summary = 'blk-summary',
}
